import { env } from '~/lib/env.ts';
import type { HasPermissionFunction } from '~/modules/remotes/types.ts';

export enum NavigationPermissionKeys {
  BULK_UPLOAD_MODAL = 'BULK_UPLOAD_MODAL',
  RELEASE_CLINIC = 'RELEASE_CLINIC',
  VIDEO_MANAGEMENT = 'VIDEO_MANAGEMENT',
  REPORTS = 'REPORTS',
  CREATE_RELEASE = 'CREATE_RELEASE',
  COOP_SETTINGS = 'COOP_SETTINGS',
  SETTINGS = 'SETTINGS',
}

export const NAVIGATION_PERMISSIONS: Record<
  NavigationPermissionKeys,
  (hasPermission: HasPermissionFunction) => boolean
> = {
  [NavigationPermissionKeys.BULK_UPLOAD_MODAL]: () =>
    env('VITE_SHOW_BULK_UPLOAD', false) === 'true',

  [NavigationPermissionKeys.RELEASE_CLINIC]: (hasPermission) =>
    hasPermission('RELEASE_CLINIC.VIEW_INTEGRATION'),

  [NavigationPermissionKeys.VIDEO_MANAGEMENT]: (hasPermission) => {
    const videoClaimingEnabled =
      env('VITE_VIDEO_CLAIMING_ENABLED', false) === 'true';
    return videoClaimingEnabled && hasPermission('VIDEO_CLAIMING.VIEW');
  },

  [NavigationPermissionKeys.REPORTS]: (hasPermission) =>
    hasPermission('REPORT.VIEW'),
  [NavigationPermissionKeys.CREATE_RELEASE]: (hasPermission) =>
    hasPermission('RELEASE.CREATE'),
  [NavigationPermissionKeys.COOP_SETTINGS]: (hasPermission) =>
    hasPermission('PLATFORM.SETTINGS'),

  [NavigationPermissionKeys.SETTINGS]: (hasPermission) => {
    const viteContainerSettingsEnabled =
      env('VITE_CONTAINER_SETTINGS_ENABLED', false) === 'true';
    return viteContainerSettingsEnabled && hasPermission('PLATFORM.SETTINGS');
  },
};
